module.exports = __webpack_public_path__ + "img/video_url_hint.8af749dc.png";